/**
 * Segment Analytics
 *
 * Primarily returns the window.analytics object
 */
export default window.analytics;
